import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Layout from "components/Layout";
import api from "utils/api";
import { setLogout } from "state";
import "styles/auth.css";

const DeleteAccountConfirmPage = () => {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [status, setStatus] = useState({
    kind: "loading",
    message: "Kontolöschung wird bestätigt...",
  });
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const ranRef = useRef(false);

  useEffect(() => {
    if (!token) {
      setStatus({ kind: "error", message: "Der Bestätigungslink ist unvollständig." });
      return;
    }
    if (ranRef.current) return;
    ranRef.current = true;
    (async () => {
      try {
        const { data } = await api.get("/auth/confirm-account-deletion", {
          params: { token },
        });
        dispatch(setLogout());
        setStatus({
          kind: "success",
          message: data.message || "Dein Konto wurde erfolgreich gelöscht.",
        });
        setTimeout(() => navigate("/", { replace: true }), 2500);
      } catch (err) {
        setStatus({
          kind: "error",
          message:
            err?.response?.data?.message ||
            "Der Bestätigungslink ist ungültig oder abgelaufen.",
        });
      }
    })();
  }, [token, dispatch, navigate]);

  return (
    <Layout>
      <section className="auth-page">
        <div className="auth-card">
          <div className="auth-kicker">Kontolöschung</div>
          <h1>
            <em>Bestätigung</em>
          </h1>
          <div className={`auth-alert is-${status.kind === "loading" ? "info" : status.kind}`}>
            {status.message}
          </div>
          <div className="auth-links">
            <Link to="/">Zur Startseite</Link>
          </div>
        </div>
      </section>
    </Layout>
  );
};

export default DeleteAccountConfirmPage;